export default "__VITE_ASSET__DuIFSkqv__"